import { makeActionCreatorObjParam } from '@trumedianetworks/tmn-core-components/src/util/redux-helpers';
import * as t from './action_types';
import { apiAction } from '../../api/store/actions';
import { actions as siteActions } from '../../site';
import { actions as userActions } from '../../user';
import { availableAuthSitesFiltersSelector } from './selectors';
import { isMobile } from './selectors';

const _setAuthSiteFilters = makeActionCreatorObjParam(t.SET_AUTH_SITE_FILTERS, 'filters');
const setIsMobile = makeActionCreatorObjParam(t.SET_IS_MOBILE, 'isMobile');
export const setAvailableAuthSiteFilters = (filters) => (dispatch, getState) => {
    dispatch(_setAuthSiteFilters({ filters }));
    //dispatch(fetchAvailableAuthSites());
};

const setAvailableAuthSites = makeActionCreatorObjParam(t.SET_AUTH_SITE_LIST, 'data');

const handleFetchAvailableAuthSitesSuccess = (data) => (dispatch) => {
    if (data?.length === 1) {
        dispatch(userActions.setActiveAuthSite({ activeAuthSite: data[0].name }));
    }
    dispatch(setAvailableAuthSites({ data }));
};

export const fetchAvailableAuthSites = () => (dispatch, getState) => {
    // we're actually going to only filter client side since the
    // client uses the available sites to provide data for the selected site
    //const filters = availableAuthSitesFiltersSelector(getState());
    dispatch(
        apiAction({
            url: '/v2/api/user-admin/available-auth-sites',
            method: 'POST',
            data: {},
            onSuccess: handleFetchAvailableAuthSitesSuccess,
            onFailure: () => {
                console.log('Error occured fetching auth site data');
            },
            label: t.FETCH_AUTH_SITE_LIST,
        })
    );
};

export const updateMobileFlag = (mobileDetected) => (dispatch, getState) => {
    const state = getState();
    const mobileState = isMobile(state);
    if (mobileState !== mobileDetected) {
        dispatch(setIsMobile({ isMobile: mobileDetected }));
    }
};
